import {config as numberPercentColumnConfig} from '../../common/NumberPercentColumn';
import {labels as utilLabels} from '../../../../../../util/utils';

const prop = 'rNOOD';

export const config = (labels) =>
	numberPercentColumnConfig({
		id: 'overdue',
		label: labels.overdueLabel,
		prop,
		getPartial: (item) => item[prop],
		getTotal: (item) => item['rNO'],
		width: 'minmax(var(--px-170), 1fr)',
		customHeaderTooltip: utilLabels.notesTableTooltipContent
	});
